import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChildren,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CommonService } from "src/@services/common.service";
import { FormService } from "src/@services/form.service";
import { CommonPagesService } from "../../common-pages.service";
import data from "src/assets/states.json";
import { NzUploadChangeParam, NzUploadFile } from "ng-zorro-antd/upload";
import { InnerPagesService } from "src/app/pages/common-layout/inner-pages.service";
import { responseMessageStatus, ResponseStatus } from "../../enum";
import { Vendor } from "src/models/vendor.model";
import { Validators } from "@angular/forms";
import { BrowserPlatformService } from "src/@services/browser-platform.service";
@Component({
  selector: "app-add-vendor-form",
  templateUrl: "./add-vendor-form.component.html",
  styleUrls: ["./add-vendor-form.component.scss"],
  standalone: false,
})
export class AddVendorFormComponent implements OnInit {
  //#region properties
  isVisibleVendorDrawer = true;
  @Output() hideVendorDrawer = new EventEmitter();
  listOfStates = data.States;
  isAddingVendor: boolean = false;
  ShowConfirmDialog: boolean = false;
  isaddLinesClicked: boolean = false;
  siteId: string = "";
  isInternationalAddress: boolean = false;
  uploadedFile: any = {};
  @Input() isEditVendor: boolean;
  @Input() currentVendorData: Vendor;
  @Output() hideEditVendor = new EventEmitter();
  @ViewChildren("zipCode") zipCode: any;

  //#endregion

  //constructor
  constructor(
    public _cS: CommonService,
    public _fS: FormService,
    private route: ActivatedRoute,
    private _cpS: CommonPagesService,
    private _iS: InnerPagesService,
    private browserPlatformService: BrowserPlatformService
  ) {
    _fS.addVendorForm_fb();
  }

  //#region functions
  ngOnInit(): void {
    this.siteId = this.route.snapshot.paramMap.get("siteId");
    this.listOfStates = data.States;
    this.uploadedFile = {};

    //patch usa to country
    // this._fS.addVendorForm.patchValue({
    //   country: "USA",
    // });

    if (this.isEditVendor) {
      this._fS.addVendorForm.patchValue({
        country: !this.currentVendorData.isAddLine
          ? this.currentVendorData.country
          : '',
        state: this.listOfStates.includes(this.currentVendorData.state)
          ? this.currentVendorData.state
          : "",
        streetAddress1: !this.currentVendorData.isAddLine ? this.currentVendorData.streetAddress1 : "",
        streetAddress2: !this.currentVendorData.isAddLine
          ? this.currentVendorData.streetAddress2
            ? this.currentVendorData.streetAddress2
            : ""
          : "",
        phoneNumber: this.currentVendorData.phoneNumber,
        city: this.currentVendorData.city ? this.currentVendorData.city : '',
        zipCode: !this.currentVendorData.isAddLine
          ? this.currentVendorData.zipCode
          : '',
        internationalAddress: this.currentVendorData.streetAddress1,
      });

      this.isaddLinesClicked = this.currentVendorData.isAddLine;
      this.isInternationalAddress = this.currentVendorData.isInternationalAddress;

      this.uploadedFile["name"] = this.currentVendorData.w9AttachmentName
        ? this.currentVendorData.w9AttachmentName
        : "";

      if (this.currentVendorData.isInternationalAddress) {
        this.isaddLinesClicked = true;
        //remove validations as not needed
        this._fS.addVendorForm.get("streetAddress1").clearValidators();
        this._fS.addVendorForm.get("city").clearValidators();
        this._fS.addVendorForm.get("state").clearValidators();
        this._fS.addVendorForm.get("zipCode").clearValidators();
        this._fS.addVendorForm.get("country").clearValidators();
        this._fS.addVendorForm.get("internationalAddress").setValidators(Validators.required);
        //update value and validity for above fields
        this._fS.addVendorForm.get("internationalAddress").updateValueAndValidity();
        this._fS.addVendorForm.get("country").updateValueAndValidity();
        this._fS.addVendorForm.get("state").updateValueAndValidity();
        this._fS.addVendorForm.get("city").updateValueAndValidity();
        this._fS.addVendorForm.get("zipCode").updateValueAndValidity();
        this._fS.addVendorForm.get("streetAddress1").updateValueAndValidity();
      }
      //remove validations as not needed
      this._fS.addVendorForm.get("companyName").clearValidators();
      this._fS.addVendorForm.get("vendorDisplayName").clearValidators();
      // this._fS.addVendorForm.get("emailAddress").clearValidators();
      // this._fS.addVendorForm.get("city").clearValidators();
      // this._fS.addVendorForm.get("state").clearValidators();
      // this._fS.addVendorForm.get("zipCode").clearValidators();
      // this._fS.addVendorForm.get("country").clearValidators();

      // //update value and validity for above fields
      // this._fS.addVendorForm.get("country").updateValueAndValidity();
      // this._fS.addVendorForm.get("state").updateValueAndValidity();
      // this._fS.addVendorForm.get("city").updateValueAndValidity();
      // this._fS.addVendorForm.get("zipCode").updateValueAndValidity();

    } else {
      //add validations while adding new vendor
      // this._fS.addVendorForm.get("streetAddress1").setValidators([this._cS.requiredValidator]);
      // this._fS.addVendorForm.get("companyName").setValidators([this._cS.requiredValidator]);
      // this._fS.addVendorForm.get("city").setValidators([this._cS.requiredValidator]);
      // this._fS.addVendorForm.get("state").setValidators([this._cS.requiredValidator]);
      // this._fS.addVendorForm.get("zipCode").setValidators([this._cS.requiredValidator]);
      // this._fS.addVendorForm.get("country").setValidators([this._cS.requiredValidator]);
    }

  }

  //close drawer
  handleCancel(data: any) {
    this.isVisibleVendorDrawer = false;
    if (this.isEditVendor) {
      this.hideEditVendor.emit(data ? data : null);
    } else {
      this.hideVendorDrawer.emit({
        hide: this.isVisibleVendorDrawer,
        data: data ? data : null,
      });
    }
  }
  confirmVendor() {
    this.ShowConfirmDialog = false;
    this.isEditVendor ? this.updateVendorDetails() : this.handleOk();
  }
  checkUploadedFile() {
    if (this._fS.addVendorForm.valid) {
      if (this.uploadedFile.name == null) {
        this.ShowConfirmDialog = true;
      } else {
        this.ShowConfirmDialog = false;
        this.isEditVendor ? this.updateVendorDetails() : this.handleOk();
      }
    } else {
      //to fire validations on invalid fields
      this._cS.markFormGroupTouched(this._fS.addVendorForm);
    }
  }
  //add or update button of drawer clicked
  handleOk() {
    if (this._fS.addVendorForm.valid) {
      // if(!this.isAddAddressClicked){
      //   this._fS.addVendorForm.patchValue({
      //     streetAddress1: '',
      //     streetAddress2: '',
      //     city: '',
      //     state: '',
      //     zipCode: '',
      //     country: '',
      //   });
      // }
      this.ShowConfirmDialog = false;

      this.isAddingVendor = true;
      const formValue = this._fS.addVendorForm.value;
      const formData = new FormData();
      formData.set("SiteId", this.siteId);
      formData.set("CompanyName", formValue.companyName.trim());
      formData.set("VendorDisplayName", formValue.vendorDisplayName.trim());
      formData.set("Email", formValue.emailAddress ? formValue.emailAddress : '');
      formData.set("PhoneNumber", formValue.phoneNumber ? formValue.phoneNumber : '');
      formData.set("StreetAddress1", this.isaddLinesClicked ? formValue.internationalAddress : formValue.streetAddress1);
      formData.set("StreetAddress2", this.isaddLinesClicked ? '' : formValue.streetAddress2);
      formData.set("City", this.isaddLinesClicked ? '' : formValue.city);
      formData.set("State", this.isaddLinesClicked ? '' : formValue.state);
      formData.set("ZIPCode", this.isaddLinesClicked ? '' : formValue.zipCode);
      formData.set("Country", this.isaddLinesClicked ? '' : formValue.country);
      formData.set("File", this.uploadedFile);
      formData.set("IsAddLine", this.isaddLinesClicked + "");
      formData.set("IsInternationalAddress", this.isaddLinesClicked + "");
      //add or edit user data
      this.addVendor(formData);
    } else {
      //to fire validations on invalid fields      
      this._cS.markFormGroupTouched(this._fS.addVendorForm);
    }
  }

  //add or update data on buttton click
  addVendor(vendorBody: any) {
    this._cpS.addVendor(vendorBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.isAddingVendor = false;
        this._cS.displayMessage(
          responseMessageStatus.success,
          response.message
        );
        //hide vendor drawer
        this.isVisibleVendorDrawer = false;

        this.hideVendorDrawer.emit({
          hide: this.isVisibleVendorDrawer,
          data: response.result,
        });
      } else {
        this.isAddingVendor = false;
        this._cS.displayMessage(responseMessageStatus.error, response.message);
      }
    });
  }

  updateVendorDetails() {
    if (this._fS.addVendorForm.valid) {
      this.isAddingVendor = true;
      const formValue = this._fS.addVendorForm.value;
      const requestData = new FormData();
      requestData.set("Id", this.currentVendorData.id);
      requestData.set(
        "QboEntityId",
        this.currentVendorData.qboEntityId != null
          ? this.currentVendorData.qboEntityId
          : ""
      );
      requestData.set("CompanyName", this.currentVendorData.companyName);
      requestData.set(
        "VendorDisplayName",
        this.currentVendorData.vendorDisplayName
      );
      requestData.set(
        "Email",
        this.currentVendorData.email != null ? this.currentVendorData.email : ""
      );
      requestData.set(
        "PhoneNumber",
        formValue.phoneNumber ? formValue.phoneNumber : ""
      );
      requestData.set("MobileNumber", "");
      requestData.set("StreetAddress1", this.isaddLinesClicked ? formValue.internationalAddress : formValue.streetAddress1);
      requestData.set("StreetAddress2", this.isaddLinesClicked ? '' : formValue.streetAddress2);
      requestData.set("City", this.isaddLinesClicked ? '' : formValue.city);
      requestData.set("State", this.isaddLinesClicked ? '' : formValue.state);
      requestData.set("ZIPCode", this.isaddLinesClicked ? '' : formValue.zipCode);
      requestData.set("Country", this.isaddLinesClicked ? '' : formValue.country);
      // requestData.set("StreetAddress1", formValue.streetAddress1 ? formValue.streetAddress1 : "");
      // requestData.set(
      //   "StreetAddress2",
      //   formValue.streetAddress2 ? formValue.streetAddress2 : ""
      // );
      // requestData.set("City", formValue.city ? formValue.city : "");
      // requestData.set("State", formValue.state ? formValue.state : "");
      // requestData.set("ZipCode", formValue.zipCode ? formValue.zipCode : "");
      // requestData.set("Country", formValue.country ? formValue.country : "");
      requestData.set("W9AttachmentURL", "");
      requestData.set(
        "W9AttachmentName",
        this.uploadedFile.name != undefined ? this.uploadedFile.name : ""
      );
      requestData.set(
        "QBOAttachmentName",
        this.currentVendorData.qboAttachmentName != null
          ? this.currentVendorData.qboAttachmentName
          : ""
      );
      requestData.set(
        "QBOAttachmentId",
        this.currentVendorData.qboAttachmentId != null
          ? this.currentVendorData.qboAttachmentId
          : ""
      );
      requestData.set(
        "Terms.Id",
        this.currentVendorData.terms ? this.currentVendorData.terms.id : ""
      );
      requestData.set(
        "Terms.Name",
        this.currentVendorData.terms ? this.currentVendorData.terms.name : ""
      );
      requestData.set(
        "PaymentType",
        this.currentVendorData.paymentType
          ? this.currentVendorData.paymentType
          : ""
      );
      requestData.set(
        "ServiceRequest.Id",
        this.currentVendorData.serviceRequest
          ? this.currentVendorData.serviceRequest.id
          : ""
      );
      requestData.set(
        "ServiceRequest.Name",
        this.currentVendorData.serviceRequest
          ? this.currentVendorData.serviceRequest.name
          : ""
      );
      requestData.set(
        "BusinessIdNo",
        this.currentVendorData.businessIdNo != null
          ? this.currentVendorData.businessIdNo
          : ""
      );
      requestData.set(
        "VendorId",
        this.currentVendorData.vendorId != null
          ? this.currentVendorData.vendorId
          : ""
      );
      requestData.set("SiteId", this.siteId);
      requestData.set(
        "W9AttachmentFile",
        this.uploadedFile.name ? this.uploadedFile : ""
      );
      requestData.set("isAddLine", this.isaddLinesClicked + "");
      requestData.set("isInternationalAddress", this.isInternationalAddress + "");
      this._iS.editVendor(requestData).subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.isAddingVendor = false;
          this.handleCancel(response.result);
          this._cS.displayMessage(
            responseMessageStatus.success,
            response.message
          );
        } else {
          this.isAddingVendor = false;
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      });
    } else {
      this._cS.markFormGroupTouched(this._fS.addVendorForm);
    }
  }
  //on upload file
  handleChangeUpload({ file }: NzUploadChangeParam) {
    if (file) {
      // this.uploadedFile = file;
    }
  }
  // check file type and validate before uploading
  beforeUpload = (file: NzUploadFile): boolean => {
    const isJpgOrPng = file.type === "application/pdf";
    if (!isJpgOrPng) {
      this._cS.displayMessage(
        responseMessageStatus.warning,
        "Only PDF files are allowed"
      );
    } else {
      this.uploadedFile = file;
      return true;
    }
    return false;
  };

  //open public url of attached w9 form
  openDocView() {
    this.currentVendorData.w9AttachmentURL &&
      this.currentVendorData.w9AttachmentName === this.uploadedFile?.name
      ? this.browserPlatformService.openInNewTab(this.currentVendorData.w9AttachmentURL)
      : event?.preventDefault;
  }
  deleteFile() {
    this.uploadedFile = {};
  }
  focusZipCode(event: any) {
    if (event) {
      this.zipCode.first.nativeElement.focus();
    }
  }
  // isAddAddressClicked: boolean = false;
  // addAddressVendor(event: boolean) {
  //   this.isAddAddressClicked = event;
  // }
  addLinesClicked(event: any) {
    this.isaddLinesClicked = event;
    this.isInternationalAddress = event;

    if (this.isaddLinesClicked) {
      // if(this.currentVendorData && !this.currentVendorData.isAddLine){
      //   this._fS.addVendorForm.patchValue({
      //     streetAddress1: this.currentVendorData.streetAddress1,
      //     streetAddress2: this.currentVendorData.streetAddress2,
      //     city: this.currentVendorData.city,
      //     state: this.currentVendorData.state,
      //     zipCode: this.currentVendorData.zipCode,
      //     country: this.currentVendorData.country,
      //   });
      // }else{
      const form = this._fS.addVendorForm.value;

      // (form.streetAddress1?.trim() || form.streetAddress2?.trim() || form.city?.trim() || form.state?.trim() || form.zipCode?.trim()) ? 

      const address =
        (form.streetAddress1?.trim() ? form.streetAddress1.trim() + "\n" : "") +
        (form.streetAddress2?.trim() ? form.streetAddress2.trim() + "\n" : "") +
        (form.city?.trim() ? form.city.trim() + ', ' : "") +
        (form.state?.trim() ? form.state.trim() + ' ' : "") +
        (form.zipCode?.trim() ? form.zipCode.trim() + '\n' : "") +
        (form.country ? form.country : "");
      this._fS.addVendorForm.patchValue({
        internationalAddress: address,
        // streetAddress1: address,
        // streetAddress2: "",
        // city: "",
        // state: "",
        // zipCode: "",
        // country: "",
      });
      if (address.trim() == '' && this.currentVendorData?.isAddLine) {
        this._fS.addVendorForm.patchValue({
          // streetAddress1: this.currentVendorData.streetAddress1,
          internationalAddress: this.currentVendorData.streetAddress1,
        });
      }

      //add validator to internationAddress field and remove validators from streetAddress1, streetAddress2, city, state, zipCode and country fields
      this._fS.addVendorForm.controls["internationalAddress"].setValidators(Validators.required);
      this._fS.addVendorForm.controls["streetAddress1"].clearValidators();
      this._fS.addVendorForm.controls["city"].clearValidators();
      this._fS.addVendorForm.controls["state"].clearValidators();
      this._fS.addVendorForm.controls["zipCode"].clearValidators();
      this._fS.addVendorForm.controls["country"].clearValidators();
      this._fS.addVendorForm.controls["country"].updateValueAndValidity();
      this._fS.addVendorForm.controls["streetAddress1"].updateValueAndValidity();
      this._fS.addVendorForm.controls["city"].updateValueAndValidity();
      this._fS.addVendorForm.controls["state"].updateValueAndValidity();
      this._fS.addVendorForm.controls["zipCode"].updateValueAndValidity();
      this._fS.addVendorForm.controls["internationalAddress"].updateValueAndValidity();
      // }
    } else {
      this._fS.addVendorForm.controls["internationalAddress"].clearValidators();
      this._fS.addVendorForm.controls["streetAddress1"].setValidators(Validators.required);
      this._fS.addVendorForm.controls["city"].setValidators(Validators.required);
      this._fS.addVendorForm.controls["state"].setValidators(Validators.required);
      this._fS.addVendorForm.controls["zipCode"].setValidators(Validators.required);
      this._fS.addVendorForm.controls["country"].setValidators(Validators.required);

      this._fS.addVendorForm.controls["internationalAddress"].updateValueAndValidity();
      this._fS.addVendorForm.controls["streetAddress1"].updateValueAndValidity();
      this._fS.addVendorForm.controls["city"].updateValueAndValidity();
      this._fS.addVendorForm.controls["state"].updateValueAndValidity();
      this._fS.addVendorForm.controls["zipCode"].updateValueAndValidity();
      this._fS.addVendorForm.controls["country"].updateValueAndValidity();

      if (this.currentVendorData && !this.currentVendorData.isAddLine) {
        //patch currentVendorData to form
        this._fS.addVendorForm.patchValue({
          streetAddress1: this.currentVendorData.streetAddress1,
          streetAddress2: this.currentVendorData.streetAddress2,
          city: this.currentVendorData.city,
          state: this.currentVendorData.state,
          zipCode: this.currentVendorData.zipCode,
          country: this.currentVendorData.country,
        });

      } else {

        // const streetAddress = this._fS.addVendorForm.value.streetAddress1.split(",");
        // const address = streetAddress[0].split("\n");
        // const stateZip = streetAddress[1].split(" ");
        // const zip = stateZip[1] ? stateZip[1].split("\n")[0] : '';
        this._fS.addVendorForm.patchValue({
          // streetAddress1: '',
          // streetAddress2: address[1] && address[1] != 'USA' ? address[1] : "",
          // city: address[2] ? address[2] : '',
          // state: stateZip[0] ? stateZip[0] : '',
          // zipCode: zip ? zip : '',
          // country: 'USA',
        });
      }

    }
  }
  //#endregion
}
